<link rel="stylesheet" [href]="assets.css" />

<div class="maintenance">
  <img class="bg" [src]="assets.img" alt="" />
  <div class="text">
    <h1>Soundcheck</h1>
    <p>Unfortunately the site is down for maintenance. We'll be back singing as soon as possible.</p>
  </div>
</div>
